import { FC } from "react";

interface DeleteTrashIconSVGProps {
    className?: string;
    strokeWidth?: string;
    onClick?: () => void;
}

const DeleteTrashIconSVG: FC<DeleteTrashIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={props.onClick}
        >
            <path
                d="M3 6H21M19 6V20C19 21 18 22 17 22H7C6 22 5 21 5 20V6M8 6V4C8 3 9 2 10 2H14C15 2 16 3 16 4V6"
                stroke="currentColor"
                strokeWidth={props.strokeWidth || "2"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default DeleteTrashIconSVG;
